import {ModalContext} from '#/contexts/modal-provider';
import {useFundingStatus} from '#/hooks/query/use-funding-status';
import {useNativeTokenBalance} from '#/hooks/query/use-native-token-balance';
import {testnetAccountFundingTargetAmounts} from '@shareland/shareland-common';
import {useContext, useEffect, useRef} from 'react';

export const useTestnetNativeTokensFunding = () => {
  const {open} = useContext(ModalContext);

  const {
    data: nativeTokenBalance,
    isLoading: nativeTokenBalanceLoading,
    isError: nativeTokenBalanceIsError,
  } = useNativeTokenBalance();
  const {data: fundingStatus, isLoading: fundingStatusIsLoading} = useFundingStatus();

  const didLoad = useRef(false);

  useEffect(() => {
    if (didLoad.current || fundingStatusIsLoading || nativeTokenBalanceLoading || nativeTokenBalanceIsError) {
      return;
    }

    if (fundingStatus && nativeTokenBalance < testnetAccountFundingTargetAmounts.minNative) {
      setTimeout(() => {
        open({name: 'AddNativeTokensModal', props: {automatic: true}});
      }, 1000);

      didLoad.current = true;
    }
  }, [
    fundingStatus,
    fundingStatusIsLoading,
    nativeTokenBalance,
    nativeTokenBalanceIsError,
    nativeTokenBalanceLoading,
    open,
  ]);
};
